import React from "react";

function SkeletonBlock({ width, height, style = {} }) {
  return (
    <div
      style={{
        width: width || "100%",
        height: height || 20,
        background: "linear-gradient(90deg, var(--bg4) 0%, var(--bdr2) 50%, var(--bg4) 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s ease-in-out infinite",
        borderRadius: 8,
        ...style,
      }}
    />
  );
}

export default function LoadingState({ message = "Loading..." }) {
  return (
    <div style={{ padding: 24, animation: "fadeIn 0.3s" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
        <div
          style={{
            width: 24,
            height: 24,
            border: "2px solid var(--gold)",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 0.6s linear infinite",
          }}
        />
        <span style={{ color: "var(--t2)", fontSize: 13 }}>{message}</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12, marginBottom: 24 }}>
        {[1, 2, 3, 4].map((i) => (
          <SkeletonBlock key={i} height={80} />
        ))}
      </div>
      <SkeletonBlock height={24} width="40%" style={{ marginBottom: 12 }} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <SkeletonBlock key={i} height={120} />
        ))}
      </div>
    </div>
  );
}
